const white = {
  white: {
    1: '#FFF',
  },
};

const background = {
  background: {
    gray: '#E5E5E5',
    ocean: '#EEFAFB',
  },
};

const indigo = {
  indigo: {
    1: '#F4F4F8',
    2: '#E0E0EB',
    3: '#C1C1D7',
    4: '#9F9FC1',
    5: '#7F7FAD',
    6: '#5D5D92;',
    7: '#46466D',
    8: '#30304B;',
    9: '#1E1E2F',
    10: '#0E0E16',
  },
};

const gray = {
  gray: {
    1: '#F4F4F4',
    2: '#E3E3E3',
    3: '#CCCCCC',
    4: '#B0B0B0',
    5: '#969696;',
    6: '#787878',
    7: '#595959',
    8: '#3D3D3D',
    9: '#262626',
    10: '#121212',
  },
};

const sand = {
  sand: {
    1: '#F5F4F3',
    2: '#E5E3E0',
    3: '#D1CCC7',
    4: '#B7B0A9',
    5: '#A0968D',
    6: '#83786D',
    7: '#615951',
    8: '#433D38',
    9: '#292622',
    10: '#131210',
  },
};

const aqua = {
  aqua: {
    1: '#EEFAFB',
    2: '#D5F2F6',
    3: '#ABE5ED',
    4: '#7DD7E3',
    5: '#52CBDA',
    6: '#2AB4C6',
    7: '#1F8693',
    8: '#155C65',
    9: '#0D393F',
    10: '#061B1D',
  },
};

const green = {
  green: {
    1: '#F2F8F3',
    2: '#DDEEE1',
    3: '#BCDCC3',
    4: '#97C9A2',
    5: '#75B883',
    6: '#519E62',
    7: '#3D7649',
    8: '#2A5132',
    9: '#1A321F',
    10: '#0C180F',
  },
};

const orange = {
  orange: {
    1: '#FDF3ED',
    2: '#F9DFCD',
    3: '#F5C5A3',
    4: '#F0A977',
    5: '#EA8741',
    6: '#D76718',
    7: '#A04D12',
    8: '#6E350C',
    9: '#452108',
    10: '#200F04',
  },
};

const yellow = {
  yellow: {
    1: '#FEF8EC',
    2: '#FCEBCA',
    3: '#FADA9E',
    4: '#F7C86F',
    5: '#F4B336',
    6: '#E3990C',
    7: '#A97209',
    8: '#744E06',
    9: '#493104',
    10: '#221702',
  },
};

const red = {
  red: {
    1: '#FFEBEB',
    2: '#FFCCCC',
    3: '#FF9999',
    4: '#FF6666',
    5: '#FF2E2E',
    6: '#F00000',
    7: '#B20000',
    8: '#790000',
    9: '#4D0000',
    10: '#240000',
  },
};

// TODO: Check if the rest of the palette is being used. If not, replace these colors with antd's colors
const neutral = {
  1: '#ffffff',
  2: '#fafafa',
  3: '#f5f5f5',
  4: '#f0f0f0',
  5: '#d9d9d9',
  6: '#bfbfbf',
  7: '#8c8c8c',
  8: '#595959',
  9: '#434343',
  10: '#262626',
  11: '#1f1f1f',
  12: '#141414',
  13: '#000000',
};

const success = '#389e0d';
const warning = '#faad14';

module.exports = {
  ...white,
  ...background,
  ...indigo,
  ...gray,
  ...sand,
  ...aqua,
  ...green,
  ...orange,
  ...yellow,
  ...red,
  neutral,
  success,
  warning,
};
